import { render, staticRenderFns } from "./TableCol.vue?vue&type=template&id=52a9bd72&"
import script from "./TableCol.vue?vue&type=script&lang=js&"
export * from "./TableCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports